<template>
	<div>
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
				<div class="stats-inner-box" style="background-color:#49B6D6">
					<div class="row" style="height: 100%">
						<div class="col-8">
						<p>Breach</p>
						<p class="stats-value">
							-
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						</div>
						<div class="col-4 icon">
						<i class="fas fa-map-marker-alt"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
				<div class="stats-inner-box" style="background-color: #F59C19;">
					<div class="row" style="height: 100%">
						<div class="col-8">
						<p>Breach Other Teritories</p>
						<p class="stats-value">
							<!-- {{ numberWithCommas(data.total_h2) }} -->
							-
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						</div>
						<div class="col-4 icon">
						<i class="fas fa-map-marked-alt"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
				<div class="stats-inner-box" style="background-color:#DC143C">
					<div class="row" style="height: 100%">
						<div class="col-8">
						<p>Return To Service</p>
						<p class="stats-value" v-if="mapData">
							{{mapData.purchase_and_service.length + mapData.purchase_and_service_distant.length}}
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						<p class="stats-value" v-else>
							Loading.....
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						</div>
						<div class="col-4 icon">
						<i class="fas fa-tools"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
				<div class="stats-inner-box" style="background-color: #BA55D3;">
					<div class="row" style="height: 100%">
						<div class="col-8">
						<p>Purchase Only</p>
						<p class="stats-value" v-if="mapData">
							{{mapData.purchase_only.length + mapData.purchase_distant.length}}
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						<p class="stats-value" v-else>
							Loading.....
							<!-- <span class="stats-value-support">(4,5)</span> -->
						</p>
						</div>
						<div class="col-4 icon">
						<i class="fas fa-dollar-sign"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div style="height:500px" ref="testMap">
		</div>
		<div class="mt-3 row">
			<h5 class="col-12 col-md-3">Legend :</h5>
			<div class="row col-md-3 col-12">
				<div class="col-3">
					<div class="dot" style="background-color:#BA55D3"></div>
				</div>
				<div class="col-9">
					<p>Purchase Only</p>
				</div>
			</div>
			<div class="row col-md-3 col-12">
				<div class="col-3">
					<div class="dot" style="background-color:#0A0"></div>
				</div>
				<div class="col-9">
					<p>Service Only</p>
				</div>
			</div>
			<div class="row col-md-3 col-12">
				<div class="col-3">
					<div class="dot" style="background-color:#0F0"></div>
				</div>
				<div class="col-9">
					<p>Purchase And Service</p>
				</div>
			</div>
		</div>
		<div class=" row">
			<div class="col-md-3"/>
			<div class=" row col-md-3 col-12">
				<div class="col-3">
					<div class="dot" style="background-color:#DC143C"></div>
				</div>
				<div class="col-9">
					<p>Purchase And Service Outside Dealer Area</p>
				</div>
			</div>
			<div class="row col-md-3 col-12">
				<div class="col-3">
					<div class="dot" style="background-color:#FFA500"></div>
				</div>
				<div class="col-9">
					<p>Purchase Only Outside Dealer Area</p>
				</div>
			</div>
			<div class="offset-md-3 row col-md-3 col-12">
				<div class="col-3">
					<div><img src="/honda.png" style="width:20px;height:20px"></div>
				</div>
				<div class="col-9">
					<p>Dealer Honda MPM</p>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core"
import * as am4maps from "@amcharts/amcharts4/maps"

export default {
	async mounted () {
		let data = await this.loadData()
		this.mapData = data
		this.createChart(data)
	},
	data () {
		return {
			map: null,
			mapData: null,
		}
	},
	props: ['area', 'data'],
	watch: {
		area : async function () {
			this.map.dispose()
			this.mapData = null
			let data = await this.loadData()
			this.mapData = data
			this.createChart(data)
		}
	},
	methods: {
		loadData () {
			let arrayData = {
				purchase_only : [],
				purchase_and_service : [],
				purchase_distant : [],
				purchase_and_service_distant : [],
				dealer : []
			}

			for (var i = 0; i < this.data.length; i++) {
				if (!this.data[i].service_lat && this.data[i].service_lng) {
					if(this.data[i].distant_buyer == 0) {
						arrayData.purchase_only.push(this.data[i])
					}
					else {
						arrayData.purchase_distant.push(this.data[i])
					}
				}
				else {
					if(this.data[i].distant_service == 0) {
						arrayData.purchase_and_service.push(this.data[i])
					}
					else {
						arrayData.purchase_and_service_distant.push(this.data[i])
					}
				}
				arrayData.dealer.push(this.data[i])
 			}

			return arrayData
		},
		createChart(data) {
			
			this.map = am4core.create(this.$refs.testMap, am4maps.MapChart);
			this.map.geodataSource.url = `/${this.area}.json`;
			
			this.map.projection = new am4maps.projections.Miller();

			var polygonSeries = new am4maps.MapPolygonSeries();


			polygonSeries.useGeodata = true;
			this.map.series.push(polygonSeries);

			var polygonTemplate = polygonSeries.mapPolygons.template;
			polygonTemplate.tooltipText = `{ADM3_EN}`;
			polygonTemplate.stroke = am4core.color("grey")

			polygonSeries.data = [{
				"id": "ID3529120",
				"fill": am4core.color("yellow")
				}, {
				"id": "ID3509220",
				"fill": am4core.color("yellow")
				}, {
				"id": "ID3501080",
				"fill": am4core.color("yellow")
				}
				, {
				"id": "ID3509110",
				"fill": am4core.color("yellow")
				}
			];

			
			polygonTemplate.events.on("hit", function(ev) {
				ev.target.series.chart.zoomToMapObject(ev.target)
			});

			// let home = chart.chartContainer.createChild(am4core.Button);
			// home.label.text = "Home";
			// home.align = "right";
			// home.events.on("hit", function(ev) {
			// 	chart.goHome();
			// });
			// Create a zoom control
			var zoomControl = new am4maps.ZoomControl();
			this.map.zoomControl = zoomControl;
			zoomControl.slider.height = 100;

			polygonTemplate.propertyFields.fill = "fill";
			

			//
			var hs = polygonTemplate.states.create("hover");
			hs.properties.fill = am4core.color("#367B25");

			// Purchase And Service

			// var imageSeries = this.map.series.push(new am4maps.MapImageSeries());
			

			// var imageSeriesTemplate = imageSeries.mapImages.template;
			// var circle = imageSeriesTemplate.createChild(am4core.Circle);
			// circle.radius = 4;
			// circle.fill = am4core.color("#00FF00");
			// circle.stroke = am4core.color("#FFF");
			// circle.strokeWidth = 1;
			// circle.nonScaling = true;
			// circle.tooltipText = "{buy_name} - {commercial_name}";

			// imageSeriesTemplate.propertyFields.latitude = "buy_lat";
			// imageSeriesTemplate.propertyFields.longitude = "buy_lng";

			// imageSeries.data =  data.purchase_and_service
			// // console.log(data)
			

			// // Purchase and Service in Distant Dealer

			// var purchaseServiceDistantSeries = this.map.series.push(new am4maps.MapImageSeries());

			// var purchaseServiceDistantSeriesTemplate = purchaseServiceDistantSeries.mapImages.template;
			// var circle = purchaseServiceDistantSeriesTemplate.createChild(am4core.Circle);
			// circle.radius = 4;
			// circle.fill = am4core.color("#DC143C");
			// circle.stroke = am4core.color("#FFF");
			// circle.strokeWidth = 1;
			// circle.nonScaling = true;
			// circle.tooltipText = "{buy_name} - {commercial_name}";

			// purchaseServiceDistantSeriesTemplate.propertyFields.latitude = "buy_lat";
			// purchaseServiceDistantSeriesTemplate.propertyFields.longitude = "buy_lng";

			// purchaseServiceDistantSeries.data = data.purchase_and_service_distant

			// // Purchase Only

			// var purchaseSeries = this.map.series.push(new am4maps.MapImageSeries());

			// var purchaseSeriesTemplate = purchaseSeries.mapImages.template;
			// var circle = purchaseSeriesTemplate.createChild(am4core.Circle);
			// circle.radius = 4;
			// circle.fill = am4core.color("#BA55D3");
			// circle.stroke = am4core.color("#FFF");
			// circle.strokeWidth = 1;
			// circle.nonScaling = true;
			// circle.tooltipText = "{buy_name} - {commercial_name}";

			// purchaseSeriesTemplate.propertyFields.latitude = "buy_lat";
			// purchaseSeriesTemplate.propertyFields.longitude = "buy_lng";

			// purchaseSeries.data = data.purchase_only

			// // Purchase Only in Distant Dealer

			// var purchaseDistantSeries = this.map.series.push(new am4maps.MapImageSeries());

			// var purchaseDistantSeriesTemplate = purchaseDistantSeries.mapImages.template;
			// var circle = purchaseDistantSeriesTemplate.createChild(am4core.Circle);
			// circle.radius = 4;
			// circle.fill = am4core.color("#FFA500");
			// circle.stroke = am4core.color("#FFF");
			// circle.strokeWidth = 1;
			// circle.nonScaling = true;
			// circle.tooltipText = "{buy_name} - {commercial_name}";

			// purchaseDistantSeriesTemplate.propertyFields.latitude = "buy_lat";
			// purchaseDistantSeriesTemplate.propertyFields.longitude = "buy_lng";

			// purchaseDistantSeries.data = data.purchase_distant
			
			// // Dealer Honda Marker
			// var imageSeries2 = this.map.series.push(new am4maps.MapImageSeries());

			// var imageSeriesTemplate2 = imageSeries2.mapImages.template;
			// var marker = imageSeriesTemplate2.createChild(am4core.Image);
			// marker.href = "/honda.png";
			// marker.width = 20;
			// marker.height = 20;
			// marker.nonScaling = true;
			// marker.tooltipText = "Dealer Honda MPM";
			// marker.horizontalCenter = "middle";
			// marker.verticalCenter = "bottom";

			// imageSeriesTemplate2.propertyFields.latitude = "dealer_lat";
			// imageSeriesTemplate2.propertyFields.longitude = "dealer_lng";

			// imageSeries2.data = this.data
		}
	}
}
</script>

<style scoped>
	.dot {
		height: 10px;
		width: 10px;
		border-radius: 50%;
		display: inline-block;
	}
</style>